module.exports = __webpack_public_path__ + "img/client-takeout_tw.4209cb3f.svg";